﻿function initUniversalsUTMParser() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Give the URL parameters variable names
    var source = urlParams.get('utm_source');
    var medium = urlParams.get('utm_medium'); 
    var campaign = urlParams.get('utm_campaign'); 
    var content = urlParams.get('utm_content'); 
    var campaignId = urlParams.get('utm_id'); 

    // Set the cookies
    if ($.cookie('utm_source') == null || $.cookie('utm_source') == "" || $.cookie('utm_source') == undefined) {
        $.cookie('utm_source', source, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if ($.cookie('utm_medium') == null || $.cookie('utm_medium') == "" || $.cookie('utm_medium') == undefined) {
        $.cookie('utm_medium', medium, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if ($.cookie('utm_campaign') == null || $.cookie('utm_campaign') == "" || $.cookie('utm_campaign') == undefined) {
        $.cookie('utm_campaign', campaign, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if ($.cookie('utm_content') == null || $.cookie('utm_content') == "" || $.cookie('utm_content') == undefined) {
        $.cookie('utm_content', content, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if ($.cookie('utm_id') == null || $.cookie('utm_id') == "" || $.cookie('utm_id') == undefined) {
        $.cookie('utm_id', campaignId, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }

    // Override the cookies if new UTM parameters are present
    if (source != undefined || source != undefined) {
            $.cookie('utm_source', source, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if (medium != null || medium != undefined) {
            $.cookie('utm_medium', medium, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if (campaign != null || campaign != undefined) {
            $.cookie('utm_campaign', campaign, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if (content != null || content != undefined) {
            $.cookie('utm_content', content, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }
    if (campaignId != null || campaignId != undefined) {
            $.cookie('utm_id', campaignId, { expires: 7, path: '/', domain: '.ddiworld.com' });
    }


    if (campaign != null || campaign != "" || campaign != undefined) {
        $('input[name=utm_campaign]').val(campaign);
    }
    if (medium != null || medium != "" || medium != undefined) {
        $('input[name=utm_medium]').val(medium);
    }
    if (source != null || source != "" || source != undefined) {
        $('input[name=utm_source]').val(source);
    }
    if (content != null || content != "" || content != undefined) {
        $('input[name=utm_content]').val(content);
    }
    if (campaignId != null || campaignId != "" || campaignId != undefined) {
        $('input[name=utm_id]').val(campaignId);
    }
}

initUniversalsUTMParser();